import { combineReducers } from 'redux';

import forumThreads from './forumThreads/reducer';
import paging from './paging/reducer';
import emojis from './emojis/reducer';
import contributeSubject from './contributeSubject/reducer';
import textEditing from './textEditing/reducer';
import status from './status/reducer';

export default combineReducers({
  forumThreads,
  paging,
  emojis,
  contributeSubject,
  textEditing,
  status
});



/** WEBPACK FOOTER **
 ** ./src/members/state/forum/reducer.js
 **/